import React from 'react';
import { ReportThisEventButton } from '../ReportThisEvent/ReportThisEventButton';
import {
    DescriptiveOrganizerInfo,
    DescriptiveOrganizerInfoProps,
} from '../_shared/OrganizerInfo/DescriptiveOrganizerInfo';
import './OrganizerPanel.scss';

export type OrganizerPanelLayoutProps = {
    shouldShowMoreEventsFromThisOrganizer?: boolean;
};

export const OrganizerPanelLayout = ({
    shouldShowMoreEventsFromThisOrganizer,
    captchaKey,
    eventId,
    eventName,
    gaCategory,
    isAuthenticated,
    organizerAvatar,
    organizerDescription,
    organizerId,
    organizerName,
    organizerUrl,
    organizerFacebook,
    organizerTwitter,
    organizerWebsite,
}: OrganizerPanelLayoutProps & DescriptiveOrganizerInfoProps) => {
    return (
        <section className="listing-organizer eds-l-pad-bot-5">
            <DescriptiveOrganizerInfo
                captchaKey={captchaKey}
                organizerAvatar={organizerAvatar}
                organizerDescription={organizerDescription}
                organizerId={organizerId}
                organizerName={organizerName}
                organizerUrl={organizerUrl}
                organizerFacebook={organizerFacebook}
                organizerTwitter={organizerTwitter}
                organizerWebsite={organizerWebsite}
                isAuthenticated={isAuthenticated}
                eventId={eventId}
                eventName={eventName}
                gaCategory={gaCategory}
            />
            <div className="eds-align--center eds-l-mar-bot-3">
                <ReportThisEventButton eventId={eventId} />
            </div>
            {shouldShowMoreEventsFromThisOrganizer && (
                <div id="listings-root__more-events-from-this-organizer"></div>
            )}
            <div id="listings-root__collections-related-to-this-event"></div>
        </section>
    );
};
